<template>
  <div id="bottom">
    <div class="footer-container">
      <!-- 公司名称 -->
      <div class="company-name">厦门泓庚航海科技有限公司</div>

      <!-- 分割线 -->
      <div class="divider"></div>

      <div class="footer-content">
        <!-- 左侧：联系信息 -->
        <div class="contact-info">
          <div class="address-item">
            <!-- 使用 Element UI 图标或自定义 SVG/Icofont -->

            <span>   <i class="el-icon-location-outline icon"></i> &nbsp; 公司地址 : 福建省厦门市火炬高新区软件园三期溪山尾路67号801</span>
          </div>
<!--          <div class="social-links">-->
<!--            &lt;!&ndash; 这里使用了微博、微信、Twitter的图标示意 &ndash;&gt;-->
<!--            <div class="el-icon-sina-weibo icon"></div>-->
<!--            <div class="el-icon-wechat icon"></div>-->
<!--            <div class="el-icon-twitter icon"></div>-->
<!--          </div>-->
        </div>

<!--        &lt;!&ndash; 右侧：导航链接 &ndash;&gt;-->
<!--        <div class="footer-links">-->
<!--          <div v-for="(group, index) in linkGroups"-->
<!--               :key="index">-->
<!--            <div v-for="link in group"-->
<!--                 :key="link">{{ link}}</div>-->
<!--          </div>-->
<!--        </div>-->
      </div>

      <!-- 底部版权信息 -->
      <div class="copyright">
        <a @click="icp"> © 2025 厦门泓庚航海科技 版权所有 闽ICP备15011792号-3</a>
        <div>技术支持：厦门泓庚航海科技有限公司</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HgOnlineBottom',

  data() {
    return {
      linkGroups: [
        ['企业介绍', '品牌介绍', '团队介绍', '关于我们'],
        ['服务范围', '产品介绍', '新闻动态', '服务品牌']
      ]
    }
  },

  mounted() {},

  methods: {
    icp() {
      window.open('https://beian.miit.gov.cn/#/Integrated/index')
    }
  }
}
</script>

<style scoped>
#bottom {
  width: 100%;
  height: 100%;
  background-color: #3d414d; /* 匹配图中的深蓝色背景 */
  color: #fff; /* 文字白色 */
  /* padding: 1rem 0 0.5rem;  */
  font-family: 'Microsoft YaHei', Arial, sans-serif;
}

.footer-container {
  max-width: 80vw; /* 设置最大宽度以居中 */
  margin: 0 auto; /* 水平居中 */
  display: flex;
  flex-direction: column;
}

/* 公司名称样式 */
.company-name {
  font-size: 0.2rem;
  font-weight: bold;
  margin: 0.2rem 0;
  text-align: left;
  display: flex;
}

/* 分割线 */
.divider {
  border-top: 1px solid rgba(255, 255, 255, 0.1); /* 浅灰色细线 */
  //margin-bottom: 0.1rem;
}

/* 主体内容布局 */
.footer-content {
  width: 100%;
  //height: 20vh;
  display: flex;
  justify-content: space-between;
  align-items: flex-start; /* 顶部对齐 */
}

/* 左侧联系信息 */
.contact-info {
  text-align: left;
}

.address-item {
  height: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.address-item span {
  display: block;
  font-size: 0.15rem;
  color: #ccc; /* 辅助文字颜色稍浅 */
}

.address-item p {
  margin: 0;
  font-size: 0.2rem;
  color: #fff;
}

.icon {
  //margin-right: 0.1rem;
  //font-size: 0.2rem;
  //vertical-align: middle;
  //height: 0.2rem;
  //width: 0.2rem;
}

/* 社交图标链接 */
.social-links {
  width: 7vw;
  display: flex;
  justify-content: space-around;
  height: 0.5rem;
  margin-top: 0.1rem;
}

/* 右侧链接列表 */
.footer-links {
  display: flex;
  justify-content: space-between;
  width: 25vw;
  height: 100%;
  font-size: 0.15rem;
}
.footer-links > div {
  width: 12vw;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-around;
  height: 0.2rem;
  height: 100%;
}

/* 版权信息 */
.copyright {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap; /* 允许换行以适应小屏幕 */
  font-size: 0.12rem;
  color: #999;
}

.copyright a {
  color: #999;
  text-decoration: none;
}

.copyright a:hover {
  color: #fff;
  text-decoration: underline;
}
.el-icon-sina-weibo {
  background: url('@/assets/head/weibo.png') no-repeat;
  background-size: 100% 100%;
}
.el-icon-wechat {
  background: url('@/assets/head/weixin.png') no-repeat;
  background-size: 100% 100%;
}
.el-icon-twitter {
  background: url('@/assets/head/tuite.png') no-repeat;
  background-size: 100% 100%;
}
</style>